import React from "react";
import Header from "../Header/Header3.js";
import Section from "../Section/Section.js";
import Card from "../Card/Card.js";
import Card1 from "../Card1/Card1.js";
import Card2 from "../Card2/Card2.js";
import Card3 from "../Card3/Card3.js";
import Site from "../SiteCard/Site.js";
import Contato from "../Contato/Contato.js";
import Faq from "../Faq/Faq.js";
import Footer from '../Footer/Footer.js';
import Local from '../Local/Local.js';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import VideoEN from './videoen.js';
import { Link } from 'react-router-dom';
import Carrossel from '../4XC/Carrossel.js';
import Form from '../Contato/Form.js';
import News from '../Resultados/Newslatter.js';
import Aplicativo from '../Resultados/Aplicativo.js';

const VideoContainer = styled.div`
  width: 100%;
`;

const Luz = styled.div`
  position: absolute;
  z-index: -1;
  width: 400px;
  height: 240px;
  background: rgba(255, 194, 34, 0.5);
  border-radius: 100px;
  filter: blur(200px); /* Valor do desfoque, ajuste conforme necessário */
  top: -100px; /* Ajuste conforme necessário para a posição desejada */
  left: 1100px; /* Ajuste conforme necessário para a posição desejada */

  animation: pulse3 2s infinite alternate;
  
  @keyframes pulse3 {
    from {
      opacity: 0.2;
    }
    to {
      opacity: 1;
    }
  }

  @media (max-width: 1000px) {
        display: none;
    }

`;

const HomeContainer = styled.div`
  z-index: 1;
  @media (max-width: 1000px) {
    overflow-x: hidden !important;
  }
`;

const Divi = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  background: #151515;
`;

const StyledLink2 = styled.a`
  color: white;
  text-decoration: none;
  font-weight: bold;
  margin:1rem;
  text-align: center;
`;

const TitleSub23 = styled.button`
  width: 200px;
  height: 50px;
  background: linear-gradient(to right, #bf8b3d, #fefebe, #bf8b3d);
  cursor: pointer;
  font-weight: 600;
  color: black;
  font-size: 1.2rem;
  border-radius: 8px;
  border: none;
  transition: 500ms;
  margin: 8px;

  &:hover{
    border: 1px solid white;
  }
`;

const Linkada = styled.a`
  color: transparent;
  display: block;
  font-size: 1.2rem;
  text-align: center;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  -webkit-background-clip: text;
  padding: 1rem;
`;

function Home() {
  const { t } = useTranslation();

  return (
    <HomeContainer>
      <Luz></Luz>
      <Header/>
      <Section/>
      <Carrossel/>

      <Card2/>
      <Site/>
      <Aplicativo/>
      <News/>
      <Faq/>
      <Footer/>
    </HomeContainer>
  );
}

export default Home;
